import { render, staticRenderFns } from "./coursecomment-drawer.vue?vue&type=template&id=97d3bb4a&"
import script from "./coursecomment-drawer.vue?vue&type=script&lang=js&"
export * from "./coursecomment-drawer.vue?vue&type=script&lang=js&"
import style0 from "./coursecomment-drawer.vue?vue&type=style&index=0&id=97d3bb4a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports